import * as React from "react"

const Sheet = ({ open, onOpenChange, children }) => {
    if (!open) return null

    return (
        <div className="fixed inset-0 z-50 flex justify-end">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
                onClick={() => onOpenChange(false)}
            />

            {/* Sheet Content */}
            <div className="relative z-50 w-full max-w-sm h-full bg-white dark:bg-zinc-950 border-l border-zinc-200 dark:border-zinc-800 shadow-xl transition-transform duration-300 ease-in-out transform translate-x-0 overflow-y-auto">
                {children}
                {/* Close Button */}
                <button
                    className="absolute top-4 right-4 p-2 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors"
                    onClick={() => onOpenChange(false)}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 text-zinc-500">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        </div>
    )
}

const SheetTrigger = ({ asChild, children, onClick }) => {
    return React.cloneElement(children, { onClick })
}

const SheetContent = ({ children, className }) => {
    return (
        <div className={`p-6 h-full ${className}`}>
            {children}
        </div>
    )
}

const SheetHeader = ({ children, className }) => {
    return (
        <div className={`flex flex-col space-y-2 text-center sm:text-left mb-6 ${className}`}>
            {children}
        </div>
    )
}

const SheetTitle = ({ children, className }) => {
    return (
        <h3 className={`text-lg font-semibold text-zinc-950 dark:text-zinc-50 ${className}`}>
            {children}
        </h3>
    )
}

const SheetDescription = ({ children, className }) => {
    return (
        <p className={`text-sm text-zinc-500 dark:text-zinc-400 ${className}`}>
            {children}
        </p>
    )
}

const SheetFooter = ({ children, className }) => {
    return (
        <div className={`flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 mt-6 ${className}`}>
            {children}
        </div>
    )
}

export {
    Sheet,
    SheetTrigger,
    SheetContent,
    SheetHeader,
    SheetFooter,
    SheetTitle,
    SheetDescription,
}
